/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Gym_Per_WeekInputs */

const nl_planning_rooster_gym_per_week = /** @type {(inputs: Planning_Rooster_Gym_Per_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gym per week`)
};

/**

* @param {Planning_Rooster_Gym_Per_WeekInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_gym_per_week = /** @type {((inputs?: Planning_Rooster_Gym_Per_WeekInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Gym_Per_WeekInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_gym_per_week(inputs)
});
export { planning_rooster_gym_per_week as "planning.rooster.gym_per_week" }